enum TenancyTypeEnum {
    None = 'NONE',
    Tenanted = 'TENANTED',
}

export default TenancyTypeEnum;
